module.exports = __webpack_public_path__ + "static/media/stateboard2020.9195c462.jpg";